import Vue from 'vue'
import App from './App.vue'
import VueMask from 'v-mask'

import router from './router'
import store from './store'

// import * as Sentry from "@sentry/browser";
// import { Vue as VueIntegration } from "@sentry/integrations";
// import { Integrations } from "@sentry/tracing";
// import VueAnalytics from 'vue-analytics'

// Only report to analytics & sentry from production
// if (process.env.NODE_ENV === 'production') {
//   Sentry.init({
//     dsn: "https://fc2dcc5967224b5facea6ba02f261dfc@sentry.bitaccel.com/2",
//     release: process.env.VUE_APP_PKG_VERSION,
//     dist: process.env.VUE_APP_COMMIT_SHA,
//     integrations: [
//       new Integrations.BrowserTracing(),
//       new VueIntegration({
//         Vue,
//         attachProps: true,
//         logErrors: false,
//         tracing: true,
//         tracingOptions: {
//           trackComponents: true
//         }
//       })
//     ],
//     tracesSampleRate: .2 // will transmit 20% of captured transactions, selected randomly
//   })

//   Vue.use(VueAnalytics, {
//   	id: 'UA-26426225-2',
//   	router
//   })
// }

Vue.use(VueMask);

Vue.config.productionTip = false

Vue.filter('formatDate', function(value) {
  if (value) {
    var date = new Date(value);
    return (date.getMonth() + 1) + '/' + date.getDate() + '/' +  date.getFullYear()
  }
});

Vue.filter('formatCurrency', function(value) {
  let new_value = Number(value)
  return new_value.toLocaleString( undefined, { style: 'currency', currency: 'USD', minimumFractionDigits: 2, maximumFractionDigits: 2 })
});

new Vue({
	router,
	store,
	render: h => h(App)
}).$mount('#app')
